// extracted by mini-css-extract-plugin
export default {"content":"Rack_content__tyHxi","title":"Rack_title__syM7e","col":"Rack_col__GKk19"};